import React, { useEffect } from "react";
import "firebaseui/dist/firebaseui.css";
import * as firebaseui from "firebaseui";
import { useNavigate } from "react-router-dom";
import { auth, uiConfig } from "./firebase";

const SignIn = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const uiConfigWithRedirect = {
      ...uiConfig,
      callbacks: {
        ...uiConfig.callbacks,
        signInSuccessWithAuthResult: () => {
          navigate("/");
          return false;
        },
      },
    };

    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);
    ui.start("#firebaseui-auth-container", uiConfigWithRedirect);
  }, [navigate]);

  return (
    <div>
      <div id="firebaseui-auth-container"></div>
    </div>
  );
};

export default SignIn;
